'use client';

import { useEffect } from 'react';

export function useModalScrollLock(isOpen: boolean, onEscape?: () => void) {
  useEffect(() => {
    if (!isOpen) return;

    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onEscape?.();
    };

    const html = document.documentElement;
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = html.style.overflow;
    const previousHtmlPaddingRight = html.style.paddingRight;

    // Compensate classic Windows scrollbar width so locking scroll does not shift layout.
    // `scrollbar-gutter: stable` already covers most cases; this is a fallback when gutters
    // are not reserved (older browsers / overlay-off preferences).
    const scrollbarWidth = window.innerWidth - html.clientWidth;
    if (scrollbarWidth > 0) {
      html.style.paddingRight = `${scrollbarWidth}px`;
    }

    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previousBodyOverflow;
      html.style.overflow = previousHtmlOverflow;
      html.style.paddingRight = previousHtmlPaddingRight;
    };
  }, [isOpen, onEscape]);
}
